<template>
  <div class="product-filter">
    <div
      v-if="$vuetify.breakpoint.xsOnly"
      class="product-filter__mobile-controller text-right"
    >
      <v-btn
        icon
        color="#FFB300"
        @click="filterIsShow = !filterIsShow"
      >
        <v-icon>filter_alt</v-icon>
      </v-btn>
    </div>
    <v-row v-if="filterIsShow">
      <v-col cols="12" md="4">
        <v-select
          :items="option"
          width="300px"
          class="mr-5"
          placeholder="Phân loại khoản thu"
          v-model="types"
          dense
          filled
          hide-details
        ></v-select>
      </v-col>
      <v-col cols="6" md="2">
        <v-btn
          class="btn elevation-0 pa-4"
          @click="onFilterChanged"
          color="#FFB300"
          dark
        >
          <v-icon>search</v-icon>
          <span>Lọc</span>
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  props: {
    defaultFilters: Object,
  },
  data: () => ({
    filterIsShow: true,
    status: '',
    option: ['Khoản thu dài hạn', 'Khoản thu ngắn hạn', 'Khoản thu khác'],
    code: '',
    types: '',
  }),
  computed: {
    ...mapState('constant', ['productStatus', 'productTypes']),
    allProductStatus() {
      return [
        {
          title: 'Tất Cả',
          status: '',
        },
        ...this.productStatus,
      ]
    },
    allProductTypes() {
      return [
        {
          title: 'Tất Cả',
          status: '',
        },
        ...this.productTypes,
      ]
    },
  },
  created() {},
  methods: {
    onFilterChanged() {
      this.$emit('onFilterChanged', {
        type: this.types,
        ...this.time,
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.product-filter__content {
  display: flex;
  align-items: center;
}
@media screen and (max-width: 600px) {
  .product-filter {
    display: block;
  }
  .product-filter__content {
    display: none;
    padding: 20px;
    background: #ffffff;
  }
  .product-filter__content--show {
    display: block;
    box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2),
      0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12) !important;
  }
  .v-input {
    margin-right: 0 !important;
    margin-bottom: 20px;
  }
  .filter__actions {
    text-align: right;
  }
}
::v-deep {
  .v-input--selection-controls,
  .v-input__slot {
    border-radius: 4px;
    margin: 0;
    padding: 0;
    &::after {
      display: none;
    }
    &::before {
      display: none;
    }
  }
}
</style>
